import {
    BIKE_TRIGGER_HISTORY_LOADING,
    BIKE_TRIGGER_HISTORY_ERROR,
    BIKE_TRIGGER_HISTORY_DELETE,
    BIKE_TRIGGER_HISTORY_SEARCH,
} from "actions/bike-trigger-history/constants";

const initialState = {
    loading: false,
    errors: [],

    list: {},
    filters: [],
    single: {}
};

export default function(state = initialState, action) {
    let list = [],
        index;

    switch (action.type) {
        case BIKE_TRIGGER_HISTORY_LOADING:
            return {
                ...state,
                loading: action.payload.content
            };
        case BIKE_TRIGGER_HISTORY_ERROR:
            return {
                ...state,
                loading: false,
                errors: action.payload.content
            };

        case BIKE_TRIGGER_HISTORY_DELETE:
            list = Object.assign({}, state.list);
            list.content = Object.assign([], list.content);
            index = list.content.findIndex(item => item.id === action.payload);
            if (index > -1) {
                list.content.splice(index, 1);
            }
            return {
                ...state,
                loading: false,
                list
            };
        case BIKE_TRIGGER_HISTORY_SEARCH:
            return {
                ...state,
                loading: false,
                list: action.payload
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/bikeTriggerHistoryReducer.js